import { render, staticRenderFns } from "./CreateEventProcessingPage.vue?vue&type=template&id=ea9ad432&scoped=true"
import script from "./CreateEventProcessingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateEventProcessingPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateEventProcessingPage.vue?vue&type=style&index=0&id=ea9ad432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9ad432",
  null
  
)

export default component.exports